import React, { useState, useEffect, useRef } from "react";
import { API_URL } from "..";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const AddAssetLayer = () => {

    const locationId =  localStorage.getItem('locationID');
  const [formValues, setFormValues] = useState({
    title: "",
    costPrice: 0,
    quantity: 0,
    description: "",
    addedOn:'',
    locationId:locationId
  });

  const [message, setMessage] = useState({
    status: false,
    reason: "",
    desc: "",
  });

  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  // Initialize Quill
  useEffect(() => {
    if (quillRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(quillRef.current, {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: "" }, { align: "center" }, { align: "right" }],
          ],
        },
        placeholder: "Enter asset description...",
      });

      quillInstance.current.root.setAttribute("dir", "ltr");
      quillInstance.current.root.setAttribute("lang", "en");

      quillInstance.current.on("text-change", () => {
        const content = quillInstance.current.root.innerHTML;
        setFormValues((prev) => ({ ...prev, description: content }));
      });
    }

    return () => {
      if (quillInstance.current) {
        quillInstance.current.off("text-change");
        quillInstance.current = null;
      }
    };
  }, []);

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formValues.title)
      return setMessage({ status: true, reason: "error", desc: "Title is required" });

    if (!formValues.costPrice || formValues.costPrice <= 0)
      return setMessage({
        status: true,
        reason: "error",
        desc: "Cost Price must be greater than 0",
      });

    if (!formValues.quantity || formValues.quantity <= 0)
      return setMessage({
        status: true,
        reason: "error",
        desc: "Quantity must be greater than 0",
      });
      if (!formValues.addedOn)
  return setMessage({ status: true, reason: "error", desc: "Added On date is required" });


    if (!formValues.description || formValues.description === "<p><br></p>")
      return setMessage({
        status: true,
        reason: "error",
        desc: "Description is required",
      });

    try {
      const response = await fetch(`${API_URL}/api/assets`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({
          status: true,
          reason: "success",
          desc: "Asset added successfully!",
        });

        setFormValues({
          title: "",
          costPrice: 0,
          quantity: 0,
          description: "",
          addedOn:'',
        });

        if (quillInstance.current) quillInstance.current.root.innerHTML = "";
      } else {
        throw new Error(data.message || "Failed to add asset");
      }
    } catch (error) {
      setMessage({
        status: true,
        reason: "error",
        desc: `Failed to add asset: ${error.message}`,
      });
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-8 col-lg-10">
            <div className="card border">
              <div className="card-body">

                {/* Alerts */}
                {message.status && (
                  <div
                    className={`alert alert-${
                      message.reason === "error" ? "danger" : "success"
                    } alert-dismissible fade show mb-20`}
                    role="alert"
                  >
                    {message.desc}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() =>
                        setMessage({ ...message, status: false })
                      }
                    ></button>
                  </div>
                )}

                {/* Form */}
                <form onSubmit={handleSubmit}>

                  {/* Title */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Asset Title <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      value={formValues.title}
                      onChange={(e) =>
                        setFormValues((prev) => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                      placeholder="Enter asset title..."
                    />
                  </div>

                  {/* Cost Price */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Cost Price <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control radius-8"
                      value={formValues.costPrice}
                      onChange={(e) =>
                        setFormValues((prev) => ({
                          ...prev,
                          costPrice: e.target.value,
                        }))
                      }
                      placeholder="0.00"
                      min="0"
                      step="0.01"
                    />
                  </div>

                  {/* Quantity */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Quantity <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control radius-8"
                      value={formValues.quantity}
                      onChange={(e) =>
                        setFormValues((prev) => ({
                          ...prev,
                          quantity: e.target.value,
                        }))
                      }
                      placeholder="Enter quantity"
                      min="1"
                    />
                  </div>
                  {/* Added On Date */}
                <div className="mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                    Added On <span className="text-danger">*</span>
                </label>
                <input
                    type="date"
                    className="form-control radius-8"
                    value={formValues.addedOn}
                    onChange={(e) =>
                    setFormValues((prev) => ({ ...prev, addedOn: e.target.value }))
                    }
                />
                </div>


                  {/* Description */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Description <span className="text-danger-600">*</span>
                    </label>
                    <div ref={quillRef} className="ql-container" />
                    <div className="form-text">
                      Provide a detailed description of the asset.
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-400 text-md px-56 py-12 radius-8"
                    >
                      Submit
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAssetLayer;
